import React, { useContext, useEffect } from 'react';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import GlobalStyled from '../../AcessoExlusivo.style';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import OverviewExclusivo from '../components/OverviewExclusivo';
import CicloExclusivo from '../components/CicloExclusivo';
import formulaLogo from './../../../../images/solutions/logo/formulaDaVitoriaLogo.png';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import { ListMateriasFVMatematica } from './ListMateriasFVMatematica';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const FormulaDaVitoriaMatematicaPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <GlobalStyled.GlobalContainer isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        title="Fórmula da Vitória – Matemática"
                        img="ExclusivoFormulaMatImagem1.jpg"
                        logo={formulaLogo}
                        arquivo={'FV_Materiais_2026/MATEMÁTICA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Visão geral_Fórmula da Vitória.pdf'}
                        nome_arquivo="Formula_Vitoria_Mat_Visao_Geral"
                        description={`
                        O <b>Fórmula da Vitória – Matemática</b> tem como foco o desenvolvimento integral dos estudantes que chegaram aos anos finais do Ensino Fundamental com defasagens importantes na aprendizagem da Matemática.
                          </br></br>
                          A proposta busca:   </br>
                          <ol style="list-style: inside disc;">
                            <li>Qualificar a linguagem matemática, tanto oral quanto escrita, promovendo a comunicação, a argumentação e a capacidade de ler, falar e escrever sobre temas matemáticos; </li>
                            <li>Fortalecer habilidades fundamentais para o desempenho escolar, a organização do pensamento e o raciocínio lógico-dedutivo; </li>
                            <li>Desenvolver o pensamento matemático e incentivar uma postura ativa diante da resolução de problemas, aproximando os conteúdos do cotidiano dos estudantes.  </li>
                          </ol>
                          </br>
                          Acesse o documento de visão geral para conhecer melhor a proposta. 
                        `}
                        // regua={
                        //     [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                        //         ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                        //         : [35].some(id => idsMyCategorias.includes(id))
                        //         ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                        //         : ''
                        // }
                    />
                    <CicloExclusivo
                        title="Curso Fórmula da Vitória Matemática"
                        description={`
                         O curso <b>Fórmula da Vitória Matemática</b> foi desenvolvido para apoiar professores, coordenadores pedagógicos, diretores e técnicos das redes públicas de ensino na implementação da proposta. 
                        </br></br>
                        Durante a formação, você vai se apropriar dos conteúdos essenciais da solução educacional e conhecer estratégias que fortalecem a aprendizagem matemática nos anos 
                        finais do Ensino Fundamental. 
                        </br></br>
                        <b>Vamos juntos nessa jornada?</b> </br>
                        Inicie agora o curso e amplie seu repertório para transformar a aprendizagem dos seus estudantes. 
                        `}
                        img="ExclusivoFormulaMatImagem2.jpg"
                        itens={[
                            {
                                title: 'Curso Fórmula da Vitória Matemática',
                                url: '/cursos/formula-da-vitoria/formula-da-vitoria-matematica?redirect=exclusivo/formula-da-vitoria-matematica',
                                isBlock: false,
                                titleIsBlock: `Esse curso não está disponível.`,
                            },
                        ]}
                    />
                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={`Acesse os materiais exclusivos do <b>Fórmula da Vitória Matemática</b> e conheça mais de perto a proposta. Eles foram pensados para apoiar sua prática e facilitar a implementação da solução na rede.`}
                        img={'anexo_storage_files_18439785008892145703.jpeg_2025-03-31-1743444431365.jpeg'}
                        items={ListMateriasFVMatematica}
                    />
                    <SessionFerramentaVideo solucaoId={7} />
                    <ContactContainer />
                </>
            )}
        </GlobalStyled.GlobalContainer>
    );
};

export default FormulaDaVitoriaMatematicaPrivate;
